import { defineStore } from 'pinia'
import { ref, readonly } from 'vue'
import { useFlash } from 'src/biz_spa/composables'
import { castAttributesForCamelCase } from 'src/biz_spa/modules/string_converter'
import axios from 'axios'

interface Service {
  name: string
  iconUrl: string
}
interface Content {
  title: string
}
export type Benefit = {
  id: string
  service: Service
  eyeCatchUrl: string
  title: string
  content: Content
}

export type BenefitsMeta = {
  totalCount: number
  totalPages: number
}

export interface ReadBenefitsParams {
  per: number,
  page: number
}

export const useBenefitsStore = defineStore('companiesBenefits', () => {
  const { updateFlash } = useFlash()
  const benefitsLoading = ref<boolean>(false)

  const benefits = ref<Benefit[]>([])
  const benefitsMeta = ref<BenefitsMeta>({
    totalCount: 0,
    totalPages: 0,
  })

  const readBenefits = async ({ companyUuid, params }: { companyUuid: string, params: ReadBenefitsParams }) => {
    benefitsLoading.value = true

    return axios
      .get(`/api/companies/${companyUuid}/benefits`, {
        params: params
      })
      .then(res => {
        benefits.value = res.data.data.map((v: Benefit) => castAttributesForCamelCase(v))
        benefitsMeta.value = castAttributesForCamelCase(res.data.meta) as BenefitsMeta
      })
      .catch(err => {
        updateFlash({ type: 'alert', message: err.response.data.errors[0].detail })
      })
      .finally(() => {
        benefitsLoading.value = false
      })
  }

  return {
    benefitsLoading: readonly(benefitsLoading),
    benefits: readonly(benefits),
    benefitsMeta: readonly(benefitsMeta),
    readBenefits,
  }
})
